import { TextInput, TextInputProps } from "@stenajs-webui/forms";
import React from "react";
import { useNumericTextInputChange } from "./NormalizeNumericString";
import { useSelectOnFocus } from "./UseSelectOnFocus";

interface Props extends TextInputProps {
  maxNumbers?: number;
  maxDecimals?: number;
  useNegativeValues?: boolean;
  stripLeadingZeros?: boolean;
  /** Selects the whole value when the field is focused, so typing replaces it. */
  selectOnFocus?: boolean;
  dataTestid?: string;
}

export const NumericTextInput: React.FC<Props> = ({
  maxNumbers,
  maxDecimals,
  useNegativeValues,
  stripLeadingZeros,
  selectOnFocus,
  dataTestid,
  onValueChange,
  onFocus,
  onMouseDown,
  onMouseUp,
  ...props
}) => {
  const onValueTextChange = useNumericTextInputChange(
    (value) => {
      onValueChange?.(value);
    },
    maxNumbers,
    maxDecimals,
    useNegativeValues,
    stripLeadingZeros
  );

  const selectHandlers = useSelectOnFocus(selectOnFocus, {
    onFocus,
    onMouseDown,
    onMouseUp,
  });

  return (
    <TextInput
      onValueChange={onValueTextChange}
      data-testid={dataTestid}
      {...props}
      {...selectHandlers}
    />
  );
};
